import { render, staticRenderFns } from "./ButtonToImageDialog.vue?vue&type=template&id=3adde7a2&scoped=true&"
import script from "./ButtonToImageDialog.vue?vue&type=script&lang=js&"
export * from "./ButtonToImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ButtonToImageDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ButtonToImageDialog.vue?vue&type=style&index=1&id=3adde7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adde7a2",
  null
  
)

export default component.exports